import { render, staticRenderFns } from "./SpiceHotelBanner.vue?vue&type=template&id=a97516be&scoped=true&"
import script from "./SpiceHotelBanner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SpiceHotelBanner.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SpiceHotelBanner.vue?vue&type=style&index=0&id=a97516be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97516be",
  null
  
)

export default component.exports